var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(68.4093 0 0 68.4093 499.9998 498.8475)",
    id: 139325
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 -4.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(45,45,45)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -5.8335)",
    d: "M 17.7915 5.8335 C 17.7915 6.17867 17.5117 6.4585 17.1665 6.4585 L 3.83317 6.4585 C 3.48799 6.4585 3.20817 6.17867 3.20817 5.8335 C 3.20817 5.48832 3.48799 5.2085 3.83317 5.2085 L 17.1665 5.2085 C 17.5117 5.2085 17.7915 5.48832 17.7915 5.8335 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(56,56,56)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -10)",
    d: "M 17.7915 10 C 17.7915 10.3452 17.5117 10.625 17.1665 10.625 L 3.83317 10.625 C 3.48799 10.625 3.20817 10.3452 3.20817 10 C 3.20817 9.65482 3.48799 9.375 3.83317 9.375 L 17.1665 9.375 C 17.5117 9.375 17.7915 9.65482 17.7915 10 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 4.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(56,56,56)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -14.1665)",
    d: "M 17.7915 14.1665 C 17.7915 14.5117 17.5117 14.7915 17.1665 14.7915 L 3.83317 14.7915 C 3.48799 14.7915 3.20817 14.5117 3.20817 14.1665 C 3.20817 13.8213 3.48799 13.5415 3.83317 13.5415 L 17.1665 13.5415 C 17.5117 13.5415 17.7915 13.8213 17.7915 14.1665 Z",
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.09096f6c2c28f477a15b40805b1a4279.svg";